module.exports = __webpack_public_path__ + "img/banner-paw-patrol.1305d7b2.jpg";